import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { UserService } from 'app/shared/services/user.service';
import { HttpService } from 'app/shared/services/http.service';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'login-component',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    trigger('showAndHideAnimation', [
      state(
        'hide',
        style({
          display: 'none',
          opacity: 0,
        })
      ),
      state(
        'show',
        style({
          display: 'block',
          opacity: 1,
        })
      ),
      transition('hide <=> show', animate('400ms')),
    ]),
  ],
})
export class LoginComponent implements OnInit {
  public user: any;
  public isLoggedIn: boolean;
  public isLoading: boolean;
  public error: string;
  public subscriptions: Array<any>;

  // Constructor
  constructor(
    public router: Router,
    public userService: UserService,
    public httpService: HttpService,
    public sharedService: SharedService,
    public dictionaryService: DictionaryService,
    public ga: GoogleAnalyticsService
  ) {
    this.user = {
      login_username: '',
      login_password: '',
      remember: false,
    };
    this.isLoading = false;
    this.error = '';
    this.subscriptions = [];
  }

  ngOnDestroy() {}

  ngOnInit() {
    this.isLoggedIn = !this.sharedService.isEmpty(localStorage.getItem('userId'));
    if (this.isLoggedIn && this.userService.networkData !== null) {
      this.router.navigate([this.userService.getDefaultRoute()]);
    }

    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'LOGIN_FAILURE') {
          this.isLoggedIn = false;
          this.error =
            response.data && response.data.length
              ? response.data
              : this.dictionaryService.get('INCORRECT_USERNAME_OR_PASSWORD');
        } else if (response.type === 'LOGOUT') {
          // Clearing Cookies
          this.sharedService.deleteAllCookies();
          this.isLoggedIn = false;
        }
      })
    );
  }

  // Login - on "Sign in" button-click
  login() {
    // Loading
    this.isLoading = true;
    // POST reqeuest
    this.subscriptions.push(
      this.httpService.post('login/submit', this.user).subscribe(
        (response: any) => {
          // If the login was successful...
          if (response.success) {
            //redirect user to proper server
            switch (response.userData.userType) {
              case 'adv':
              case 'admin':
                if (
                  this.sharedService.environment &&
                  this.sharedService.environment.type &&
                  this.sharedService.environment.type === 'publisher'
                ) {
                  localStorage.removeItem('userId');
                  localStorage.removeItem('userData');
                  localStorage.removeItem('userDataSignature');
                  this.redirectTo('dashboard');
                  return false;
                }
                break;

              case 'publisher':
              case 'cedatopub':
                if (
                  this.sharedService.environment &&
                  this.sharedService.environment.type &&
                  this.sharedService.environment.type === 'dashboard'
                ) {
                  localStorage.removeItem('userId');
                  localStorage.removeItem('userData');
                  localStorage.removeItem('userDataSignature');
                  this.redirectTo('publisher');
                  return false;
                }
                break;

              default:
                break;
            }

            const respData = _.cloneDeep(response);

            // User-type based behavior
            switch (respData.userData.userType) {
              case 'adv':
              case 'admin':
              case 'publisher':
              case 'cedatopub':
                // Is logged in
                this.isLoggedIn = true;
                if (respData.userData) {
                  if (respData.userData.userType) { this.userService.userData.userType = respData.userData.userType; }

                  if (respData.userData.networkId) { this.userService.userData.networkId = respData.userData.networkId; }
                }

                if (this.userService.isCedatoPublisher(respData.userData)) {
                  this.userService.userData.userType = 'cedatopub';
                  respData.userData.userType = 'cedatopub';
                }

                // Save the current user-data in the localStorage
                localStorage.setItem('userId', respData.userId);
                localStorage.setItem(
                  'userData',
                  JSON.stringify({ ...respData.userData, username: this.user.login_username })
                );
                const userDataSignature: string = this.sharedService.hashString(
                  localStorage.getItem('userData') + localStorage.getItem('userData')
                );
                localStorage.setItem('userDataSignature', userDataSignature);
                // Reload the page (will redirect to the default page, when the user is authenticated)
                this.sharedService.sendMessage('LOGIN');
                break;

              default:
                this.error = this.dictionaryService.get('AN_ERROR_HAS_OCCURRED');
            }
          } else {
            // Display the error message
            this.error = response.message;
          }
          // Not loading
          this.isLoading = false;
        },
        (error: any) => {
          // Display the error message
          this.error = error.error.message;
          // Not loading
          this.isLoading = false;
        }
      )
    );
  }

  redirectTo(type: string) {
    const mainDomain = '.cedato.com';
    let redirectURL = `//${type}`;

    if (this.sharedService.environment && this.sharedService.environment.name) {
      if (this.sharedService.environment.name === 'stage') {
        redirectURL += '-stage' + mainDomain;
      } else if (this.sharedService.environment.name === 'featurestage') {
        redirectURL += '-featurestage' + mainDomain;
      } else {
        redirectURL += mainDomain;
      }
    } else {
      redirectURL += mainDomain;
    }
    window.location.href = redirectURL;
  }

  // On key-down even
  onKeyDown($event: any) {
    this.error = '';
    if ($event.which === 13) {
      this.login();
    }
  }
}
